import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { classNames } from '@egds/react-core/utils';
import { EGDSFullSheetServerSideRender } from '../full-sheet-server-side-render/index.esm.js';
import { EGDSCenteredSheetServerSideRender } from '../centered-sheet-server-side-render/index.esm.js';
import '../sheet-server-side-render-content/index.esm.js';
import '../sheet-server-side-render-close-button/index.esm.js';
import styles from '../../../../../styles/egds-app-growth-sheet-server-side-render.css';

/* istanbul ignore file */
const getClassNameList = classNames.bind(styles);
const SheetServerSideRender = props => {
  const {
    autoFocus = true,
    children,
    className,
    type = 'full',
    onDismiss
  } = props;
  const baseClassName = 'egds-server-sheet';
  const sheetClassNames = getClassNameList(className, baseClassName);
  switch (type) {
    case 'full':
      return React.createElement(EGDSFullSheetServerSideRender, {
        ...props,
        type: "full",
        className: sheetClassNames,
        autoFocus: autoFocus,
        onDismiss: onDismiss
      }, children);
    case 'centered':
      return React.createElement(EGDSCenteredSheetServerSideRender, {
        ...props,
        type: "centered",
        className: sheetClassNames,
        autoFocus: autoFocus,
        onDismiss: onDismiss
      }, children);
    default:
      return React.createElement(EGDSFullSheetServerSideRender, {
        ...props,
        type: "full",
        className: sheetClassNames,
        autoFocus: autoFocus,
        onDismiss: onDismiss
      }, children);
  }
};
const EGDSSheetServerSideRender = props => {
  const l10n = useLocalization();
  return React.createElement(SheetServerSideRender, {
    l10n: l10n,
    ...props
  });
};
EGDSSheetServerSideRender.displayName = 'EGDSServerSheet';
export { EGDSSheetServerSideRender };